import { useCallback } from "react"
import { useHistory } from "react-router-dom"
import * as Sentry from "@sentry/react"

export const useCaptureException = () => {
  const history = useHistory()
  const captureException = useCallback(
    (err: unknown) => {
      Sentry.captureException(err)
      console.error(err)
      history.push("/error")
    },
    [history]
  )
  return captureException
}
